
//Représente les paramètres de mise à jour de l’activation des factures d’achat (SU #117315)
//  La liste porte les lignes cochées de la grille, à défaut la ligne au focus. Elle ne peut pas
//  être vide : la route la refuse, et le menu est grisé sans sélection.
//  L’état cible est explicite et s’applique à toute la sélection — un basculement ligne par ligne
//  sur des lignes d’états mêlés donnerait un résultat imprévisible pour l’utilisateur.
export class AeFMettreAJourActivationFacturesAchatParametres
{
  //Identifiants des factures sélectionnées dans la grille
  public identifiantsFactures!: string[];

  //Vrai pour désactiver les factures, faux pour les réactiver
  public desactiver!: boolean;
}

//Représente le résultat de la mise à jour de l’activation des factures d’achat (SU #117315)
export class AeFMettreAJourActivationFacturesAchatResultat
{
  //Création
  constructor ()
  {
    this.nombreFacturesModifiees = 0;
    this.nombreFacturesInchangees = 0;
  }

  //Nombre de factures dont l’activation a été modifiée
  public nombreFacturesModifiees: number;

  //Nombre de factures déjà dans l’état demandé
  public nombreFacturesInchangees: number;
}
